// Auto-generated from contracts/out/HybridEscrow.sol/HybridEscrow.json by `forge build`.
// Regenerate after any contract change: see packages/chain/README or the export command in
// this repo history. Do not hand-edit.
export const hybridEscrowAbi = [
    {
        type: "constructor",
        inputs: [
            {
                name: "usdcToken",
                type: "address",
                internalType: "address",
            },
            {
                name: "initialTreasury",
                type: "address",
                internalType: "address",
            },
            {
                name: "initialArbitrator",
                type: "address",
                internalType: "address",
            },
            {
                name: "initialAdmin",
                type: "address",
                internalType: "address",
            },
            {
                name: "initialMinPrincipal",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "minDisputeDuration",
                type: "uint40",
                internalType: "uint40",
            },
            {
                name: "maxDisputeDuration",
                type: "uint40",
                internalType: "uint40",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "ARBITRATOR_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "BPS_DENOMINATOR",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "DEFAULT_ADMIN_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "MAX_DISPUTE_DURATION",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint40",
                internalType: "uint40",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "MIN_DISPUTE_DURATION",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint40",
                internalType: "uint40",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "PLATFORM_FEE_BPS",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "USDC",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IERC20",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "claimAfterDeadline",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "fundEscrow",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "seller",
                type: "address",
                internalType: "address",
            },
            {
                name: "principalAmount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "disputeDeadline",
                type: "uint40",
                internalType: "uint40",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "getEscrow",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [
            {
                name: "",
                type: "tuple",
                internalType: "struct HybridEscrow.Escrow",
                components: [
                    {
                        name: "buyer",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "seller",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "principal",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "platformFeeBpsUsed",
                        type: "uint16",
                        internalType: "uint16",
                    },
                    {
                        name: "platformFee",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "totalCharged",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "treasuryAtFunding",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "fundedAt",
                        type: "uint40",
                        internalType: "uint40",
                    },
                    {
                        name: "disputeDeadline",
                        type: "uint40",
                        internalType: "uint40",
                    },
                    {
                        name: "state",
                        type: "uint8",
                        internalType: "enum HybridEscrow.State",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getRoleAdmin",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getState",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [
            {
                name: "",
                type: "uint8",
                internalType: "enum HybridEscrow.State",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "grantRole",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "hasRole",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "minPrincipal",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "openDispute",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "evidenceHash",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "pause",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "paused",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "quote",
        inputs: [
            {
                name: "principal",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "platformFee",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "totalDue",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "pure",
    },
    {
        type: "function",
        name: "recoverERC20",
        inputs: [
            {
                name: "token",
                type: "address",
                internalType: "address",
            },
            {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "release",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "renounceRole",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "callerConfirmation",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "resolveDispute",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "buyerAmount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "sellerAmount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "resolutionHash",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "revokeRole",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setMinPrincipal",
        inputs: [
            {
                name: "newMinPrincipal",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setTreasury",
        inputs: [
            {
                name: "newTreasury",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "supportsInterface",
        inputs: [
            {
                name: "interfaceId",
                type: "bytes4",
                internalType: "bytes4",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "treasury",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "unpause",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "withdraw",
        inputs: [
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "withdrawable",
        inputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "event",
        name: "ClaimedAfterDeadline",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "seller",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "amount",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "DisputeOpened",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "buyer",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "evidenceHash",
                type: "bytes32",
                indexed: false,
                internalType: "bytes32",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "DisputeResolved",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "arbitrator",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "buyerAmount",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
            {
                name: "sellerAmount",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
            {
                name: "resolutionHash",
                type: "bytes32",
                indexed: false,
                internalType: "bytes32",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "EscrowFunded",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "buyer",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "seller",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "principal",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
            {
                name: "platformFeeBps",
                type: "uint16",
                indexed: false,
                internalType: "uint16",
            },
            {
                name: "platformFee",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
            {
                name: "totalCharged",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
            {
                name: "treasury",
                type: "address",
                indexed: false,
                internalType: "address",
            },
            {
                name: "fundedAt",
                type: "uint40",
                indexed: false,
                internalType: "uint40",
            },
            {
                name: "disputeDeadline",
                type: "uint40",
                indexed: false,
                internalType: "uint40",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "MinPrincipalUpdated",
        inputs: [
            {
                name: "oldMinPrincipal",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
            {
                name: "newMinPrincipal",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "Paused",
        inputs: [
            {
                name: "account",
                type: "address",
                indexed: false,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "PayoutCredited",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "amount",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "Released",
        inputs: [
            {
                name: "orderId",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "seller",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "amount",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoleAdminChanged",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "previousAdminRole",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "newAdminRole",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoleGranted",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "sender",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoleRevoked",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "sender",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "TokenRecovered",
        inputs: [
            {
                name: "token",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "amount",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "TreasuryUpdated",
        inputs: [
            {
                name: "oldTreasury",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "newTreasury",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "Unpaused",
        inputs: [
            {
                name: "account",
                type: "address",
                indexed: false,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "Withdrawn",
        inputs: [
            {
                name: "account",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "amount",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "error",
        name: "AccessControlBadConfirmation",
        inputs: [],
    },
    {
        type: "error",
        name: "AccessControlUnauthorizedAccount",
        inputs: [
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
            {
                name: "neededRole",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
    },
    {
        type: "error",
        name: "BuyerEqualsSeller",
        inputs: [],
    },
    {
        type: "error",
        name: "CannotRecoverEscrowToken",
        inputs: [],
    },
    {
        type: "error",
        name: "DeadlineNotReached",
        inputs: [],
    },
    {
        type: "error",
        name: "DeadlinePassed",
        inputs: [],
    },
    {
        type: "error",
        name: "EnforcedPause",
        inputs: [],
    },
    {
        type: "error",
        name: "ExpectedPause",
        inputs: [],
    },
    {
        type: "error",
        name: "InsufficientContractBalance",
        inputs: [
            {
                name: "available",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "required",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "InvalidDisputeDeadline",
        inputs: [],
    },
    {
        type: "error",
        name: "InvalidState",
        inputs: [
            {
                name: "expected",
                type: "uint8",
                internalType: "enum HybridEscrow.State",
            },
            {
                name: "actual",
                type: "uint8",
                internalType: "enum HybridEscrow.State",
            },
        ],
    },
    {
        type: "error",
        name: "NotBuyer",
        inputs: [],
    },
    {
        type: "error",
        name: "NotSeller",
        inputs: [],
    },
    {
        type: "error",
        name: "NothingToWithdraw",
        inputs: [],
    },
    {
        type: "error",
        name: "OrderAlreadyExists",
        inputs: [],
    },
    {
        type: "error",
        name: "PrincipalTooLow",
        inputs: [
            {
                name: "provided",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "minimum",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "ReentrancyGuardReentrantCall",
        inputs: [],
    },
    {
        type: "error",
        name: "SafeERC20FailedOperation",
        inputs: [
            {
                name: "token",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "SelfAddressNotAllowed",
        inputs: [],
    },
    {
        type: "error",
        name: "SplitAmountMismatch",
        inputs: [
            {
                name: "buyerAmount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "sellerAmount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "principal",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "ZeroAddress",
        inputs: [],
    },
];
//# sourceMappingURL=hybridEscrowAbi.js.map